import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PhotoGrid from './components/PhotoGrid';
import PhotoLightbox from './components/PhotoLightbox';
import CustomerTestimonials from './components/CustomerTestimonials';
import PhotoSubmission from './components/PhotoSubmission';
import InstagramFeed from './components/InstagramFeed';
import Icon from '../../components/AppIcon';

const Gallery = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);

  const galleryPhotos = [
  {
    id: 1,
    category: 'food',
    categoryLabel: 'Our Food',
    title: 'Classic Chapati Platter',
    description: 'Freshly made chapatis served with our signature spicy bean stew and grilled chicken',
    image: "https://i.ibb.co/ZzgWZ0gy/Rolex-Beef.jpg",
    imageAlt: 'Golden brown chapatis arranged on white plate with colorful bean stew and grilled chicken pieces garnished with fresh herbs',
    likes: 342,
    date: 'January 2, 2026'
  },
  {
    id: 2,
    category: 'food',
    categoryLabel: 'Our Food',
    title: 'Beef Chapati Roll',
    description: 'Tender beef strips wrapped in soft chapati with fresh vegetables and our special sauce',
    image: "https://i.ibb.co/R4PsFX2x/Rolex-Veg.jpg",
    imageAlt: 'Rolled chapati filled with seasoned beef strips, lettuce, tomatoes and white sauce on wooden serving board',
    likes: 289,
    date: 'January 1, 2026'
  },
  {
    id: 3,
    category: 'food',
    categoryLabel: 'Our Food',
    title: 'Vegetarian Delight',
    description: 'Wholesome vegetable curry with perfectly cooked chapatis and fresh salad',
    image: "https://i.ibb.co/jkdWF6Kg/order.jpg",
    imageAlt: 'Colorful vegetable curry in ceramic bowl with stack of warm chapatis and fresh green salad on side',
    likes: 267,
    date: 'December 30, 2025'
  },
  {
    id: 4,
    category: 'ambiance',
    categoryLabel: 'Restaurant',
    title: 'Modern Dining Space',
    description: 'Our comfortable and clean dining area perfect for families and friends',
    image: "https://i.ibb.co/spMdFSyt/Shop.jpg",
    imageAlt: 'Modern restaurant interior with wooden tables, comfortable chairs, warm lighting and decorative plants creating welcoming atmosphere',
    likes: 198,
    date: 'December 28, 2025'
  },
  {
    id: 5,
    category: 'ambiance',
    categoryLabel: 'Restaurant',
    title: 'Outdoor Seating Area',
    description: 'Enjoy your meal in our beautiful outdoor space with Juba city views',
    image: "https://i.ibb.co/Wv9wkBRn/shop-1.jpg",
    imageAlt: 'Outdoor restaurant patio with umbrella-covered tables, wooden chairs and city skyline view in background',
    likes: 156,
    date: 'December 25, 2025'
  },
  {
    id: 6,
    category: 'customers',
    categoryLabel: 'Happy Customers',
    title: 'Family Celebration',
    description: 'The Musa family celebrating their daughter\'s graduation with us',
    image: "https://i.ibb.co/j9cGk8zR/Customer-11.jpg",
    imageAlt: 'Happy African family of five sitting around restaurant table with food, smiling and celebrating together',
    likes: 423,
    date: 'December 24, 2025'
  },
  {
    id: 7,
    category: 'customers',
    categoryLabel: 'Happy Customers',
    title: 'Friends Gathering',
    description: 'Great times with great food - our customers enjoying their favorite meals',
    image: "https://i.ibb.co/Mytn14ZY/Customer.jpg",
    imageAlt: 'Group of young friends laughing and enjoying meals together at restaurant table with multiple dishes',
    likes: 378,
    date: 'December 22, 2025'
  },
  {
    id: 8,
    category: 'customers',
    categoryLabel: 'Happy Customers',
    title: 'Fresh Chapati Making',
    description: 'Our skilled chefs preparing fresh chapatis every day',
    image: "https://i.ibb.co/ynRNyfWj/Customer-8.jpg",
    imageAlt: 'Chef in white uniform rolling out chapati dough on floured surface in professional kitchen',
    likes: 234,
    date: 'December 20, 2025'
  },
  {
    id: 9,
    category: 'preparation',
    categoryLabel: 'Behind The Scenes',
    title: 'Kitchen Excellence',
    description: 'Our clean, modern kitchen where magic happens',
    image: "https://i.ibb.co/YTJxxQDh/staff.jpg",
    imageAlt: 'Professional restaurant kitchen with stainless steel equipment, organized cooking stations and chefs preparing food',
    likes: 189,
    date: 'December 18, 2025'
  },
  {
    id: 10,
    category: 'food',
    categoryLabel: 'Our Food',
    title: 'Chicken Chapati Combo',
    description: 'Grilled chicken with chapatis, rice, and our famous hot sauce',
    image: "https://i.ibb.co/5XHdq2Wz/Kikomando.jpg",
    imageAlt: 'Grilled chicken pieces on plate with stack of chapatis, white rice and red hot sauce in small bowl',
    likes: 412,
    date: 'December 15, 2025'
  },
  {
    id: 11,
    category: 'food',
    categoryLabel: 'Our Food',
    title: 'Breakfast Special',
    description: 'Start your day right with our breakfast chapati and eggs',
    image: "https://i.ibb.co/RkGWW6wd/Customer-10.jpg",
    imageAlt: 'Breakfast plate with warm chapatis, scrambled eggs, grilled tomatoes and fresh orange juice',
    likes: 298,
    date: 'December 12, 2025'
  },
  {
    id: 12,
    category: 'customers',
    categoryLabel: 'Happy Customers',
    title: 'Business Lunch',
    description: 'Perfect spot for business meetings and professional gatherings',
    image: "https://i.ibb.co/j9MWvY20/Customer-7.jpg",
    imageAlt: 'Professional business people in formal attire having lunch meeting at restaurant table with laptops and food',
    likes: 167,
    date: 'December 10, 2025'
  }];


  const testimonials = [
  {
    id: 1,
    name: 'Ayur Goljok',
    location: 'Juba, Munuki',
    rating: 5,
    review: 'The best chapatis in Juba! Fresh, soft, and always delicious. The delivery is fast and the staff is very friendly. I order from Chapati Plus at least twice a week.',
    customerImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1ad91979a-1763295629510.png",
    customerImageAlt: 'Professional headshot of African woman with braided hair wearing blue blouse smiling warmly',
    foodImage: "https://images.unsplash.com/photo-1704359493582-cbe7c97c98cf",
    foodImageAlt: 'Golden brown chapatis with bean stew on white plate',
    date: 'January 3, 2026'
  },
  {
    id: 2,
    name: 'James Deng',
    location: 'Juba, Gudele',
    rating: 5,
    review: 'Amazing food quality and great prices! The beef chapati roll is my favorite. Perfect for lunch breaks. Highly recommend to everyone in Juba.',
    customerImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1af4cdc9f-1763301735986.png",
    customerImageAlt: 'Professional headshot of African man with short hair wearing white shirt with confident smile',
    foodImage: "https://images.unsplash.com/photo-1560883389-3bd36d16d021",
    foodImageAlt: 'Beef chapati roll with vegetables on wooden board',
    date: 'January 2, 2026'
  },
  {
    id: 3,
    name: 'Mary Nyandeng',
    location: 'Juba, Kator',
    rating: 5,
    review: 'Clean restaurant, friendly service, and delicious food. My family loves eating here. The outdoor seating is perfect for weekend gatherings.',
    customerImage: "https://img.rocket.new/generatedImages/rocket_gen_img_15dd83987-1763295481224.png",
    customerImageAlt: 'Professional headshot of African woman with natural hair wearing red dress with bright smile',
    date: 'December 31, 2025'
  },
  {
    id: 4,
    name: 'Peter Garang',
    location: 'Juba, Jebel',
    rating: 5,
    review: 'Fast WhatsApp ordering and quick delivery! The food always arrives hot and fresh. Best fast food experience in South Sudan.',
    customerImage: "https://img.rocket.new/generatedImages/rocket_gen_img_19756913c-1763296067225.png",
    customerImageAlt: 'Professional headshot of African man with glasses wearing blue shirt with friendly expression',
    foodImage: "https://images.unsplash.com/photo-1706002750074-4a322c58321b",
    foodImageAlt: 'Vegetable curry with chapatis and salad',
    date: 'December 29, 2025'
  },
  {
    id: 5,
    name: 'Grace Achol',
    location: 'Juba, Hai Cinema',
    rating: 5,
    review: 'The vegetarian options are excellent! As someone who doesn\'t eat meat, I appreciate the variety and taste. The staff is very accommodating.',
    customerImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1a500d436-1763299083198.png",
    customerImageAlt: 'Professional headshot of African woman with short hair wearing green top with warm smile',
    date: 'December 27, 2025'
  },
  {
    id: 6,
    name: 'David Majok',
    location: 'Juba, Thongpiny',
    rating: 5,
    review: 'Great place for business lunches. Professional atmosphere and quick service. The food quality is consistently excellent.',
    customerImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d611fea9-1763295331457.png",
    customerImageAlt: 'Professional headshot of African man in business suit with confident professional demeanor',
    date: 'December 25, 2025'
  }];


  const instagramPosts = [
  {
    id: 1,
    image: "https://i.ibb.co/ZzgWZ0gy/Rolex-Beef.jpg",
    imageAlt: 'Golden brown chapatis with colorful bean stew on white plate',
    likes: 542,
    comments: 23,
    isNew: true
  },
  {
    id: 2,
    image: "https://i.ibb.co/RkGWW6wd/Customer-10.jpg",
    imageAlt: 'Beef chapati roll with fresh vegetables on wooden board',
    likes: 489,
    comments: 18,
    isNew: true
  },
  {
    id: 3,
    image: "https://ibb.co/BKjn3PMj",
    imageAlt: 'Vegetable curry with stack of chapatis and fresh salad',
    likes: 467,
    comments: 15,
    isNew: false
  },
  {
    id: 4,
    image: "https://i.ibb.co/Wv9wkBRn/shop-1.jpg",
    imageAlt: 'Happy family celebrating at restaurant table with food',
    likes: 623,
    comments: 34,
    isNew: false
  },
  {
    id: 5,
    image: "https://i.ibb.co/PvMRQkQN/Customer-3.jpg",
    imageAlt: 'Grilled chicken with chapatis and rice on plate',
    likes: 512,
    comments: 21,
    isNew: false
  },
  {
    id: 6,
    image: "https://i.ibb.co/ynRNyfWj/Customer-8.jpg",
    imageAlt: 'Breakfast plate with chapatis and scrambled eggs',
    likes: 398,
    comments: 12,
    isNew: false
  },
  {
    id: 7,
    image: "https://i.ibb.co/8ndL85c2/Customer-6.jpg",
    imageAlt: 'Chef rolling out chapati dough in professional kitchen',
    likes: 434,
    comments: 19,
    isNew: false
  },
  {
    id: 8,
    image: "https://i.ibb.co/Y4mwjLF1/4.jpg",
    imageAlt: 'Modern restaurant interior with wooden tables and warm lighting',
    likes: 356,
    comments: 8,
    isNew: false
  }];


  const handlePhotoClick = (photo) => {
    const index = galleryPhotos?.findIndex((p) => p?.id === photo?.id);
    setSelectedPhotoIndex(index);
    setSelectedPhoto(photo);
  };

  const handleNextPhoto = () => {
    const nextIndex = (selectedPhotoIndex + 1) % galleryPhotos?.length;
    setSelectedPhotoIndex(nextIndex);
    setSelectedPhoto(galleryPhotos?.[nextIndex]);
  };

  const handlePreviousPhoto = () => {
    const prevIndex = selectedPhotoIndex === 0 ? galleryPhotos?.length - 1 : selectedPhotoIndex - 1;
    setSelectedPhotoIndex(prevIndex);
    setSelectedPhoto(galleryPhotos?.[prevIndex]);
  };

  return (
    <>
      <Helmet>
        <title>Gallery - Chapati Plus | Food Photos & Customer Reviews</title>
        <meta name="description" content="Browse our gallery of delicious food photos, happy customers, and restaurant atmosphere. See why Chapati Plus is Juba's favorite fast food destination." />
        <meta name="keywords" content="Chapati Plus gallery, food photos, customer reviews, restaurant photos, Juba food, South Sudan restaurant" />
      </Helmet>
      <div className="min-h-screen bg-background flex flex-col">
        <Header />

        <main className="flex-1 pt-20 md:pt-24">
          <section className="bg-gradient-to-br from-primary/10 to-secondary/10 py-12 md:py-16 lg:py-20">
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <Icon name="Images" size={40} color="var(--color-primary)" />
              </div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 md:mb-6">
                Our Gallery
              </h1>
              <p className="text-muted-foreground text-base md:text-lg lg:text-xl max-w-3xl mx-auto">
                Explore our collection of delicious food, happy customers, and the vibrant atmosphere that makes Chapati Plus special
              </p>
            </div>
          </section>

          <section className="py-12 md:py-16 lg:py-20">
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
              <PhotoGrid photos={galleryPhotos} onPhotoClick={handlePhotoClick} />
            </div>
          </section>

          <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
              <CustomerTestimonials testimonials={testimonials} />
            </div>
          </section>

          <section className="py-12 md:py-16 lg:py-20">
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
              <InstagramFeed posts={instagramPosts} />
            </div>
          </section>

          <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
              <PhotoSubmission />
            </div>
          </section>
        </main>

        <Footer />

        {selectedPhoto &&
        <PhotoLightbox
          photo={selectedPhoto}
          onClose={() => setSelectedPhoto(null)}
          onNext={handleNextPhoto}
          onPrevious={handlePreviousPhoto}
          hasNext={selectedPhotoIndex < galleryPhotos?.length - 1}
          hasPrevious={selectedPhotoIndex > 0} />

        }
      </div>
    </>);

};

export default Gallery;